var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9668 13.7617L4.6543 8.44922C4.28711 8.08203 4.28711 7.48828 4.6543 7.125L5.53711 6.24219C5.9043 5.875 6.49805 5.875 6.86133 6.24219L10.627 10.0078L14.3926 6.24219C14.7598 5.875 15.3535 5.875 15.7168 6.24219L16.5996 7.125C16.9668 7.49219 16.9668 8.08594 16.5996 8.44922L11.2871 13.7617C10.9277 14.1289 10.334 14.1289 9.9668 13.7617Z",
    fill: "#E7EF7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDownIcon);
export default __webpack_public_path__ + "static/media/angle-down-icon.704ce9706f7d85d4fa422f23762bea28.svg";
export { ForwardRef as ReactComponent };